export default __webpack_public_path__ + "static/media/baile.3cf6725c.svg";